import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { selectSelectedBotId } from '@/store/chat/selectors';

/**
 * Хук для получения botId из различных источников
 * @param {string} defaultBotId - ID по умолчанию
 * @returns {string|null} botId
 */
export const useBotId = (defaultBotId = '1') => {
  const [botId, setBotId] = useState(null);
  const params = useParams();
  const location = useLocation();
  const selectedBotId = useSelector(selectSelectedBotId);

  useEffect(() => {
    // Приоритет: выбранный бот из store
    if (selectedBotId) {
      setBotId(selectedBotId);
      return;
    }
    let currentBotId = null;

    // 1. Из URL параметров (приоритет)
    if (params.botId) {
      currentBotId = params.botId;
    }
    // 2. Из query параметров
    else {
      const searchParams = new URLSearchParams(location.search);
      currentBotId = searchParams.get('botId') || searchParams.get('bot_id');
    }

    // 3. Из hash параметров (для SPA)
    if (!currentBotId && location.hash) {
      const hashParams = new URLSearchParams(location.hash.replace('#', ''));
      currentBotId = hashParams.get('botId') || hashParams.get('bot_id');
    }

    // 4. Из localStorage как fallback
    if (!currentBotId) {
      try {
        currentBotId = localStorage.getItem('lastUsedBotId');
      } catch (error) {
        console.warn('Не удалось получить botId из localStorage:', error);
      }
    }

    // 5. Используем значение по умолчанию, если ничего не найдено
    // if (!currentBotId) {
    //   currentBotId = defaultBotId;
    // }

    setBotId(currentBotId);

    // Сохраняем в localStorage для последующего использования
    if (currentBotId && currentBotId !== defaultBotId) {
      try {
        localStorage.setItem('lastUsedBotId', currentBotId);
      } catch (error) {
        console.warn('Не удалось сохранить botId в localStorage:', error);
      }
    }
  }, [params, location, defaultBotId, selectedBotId]);

  return botId;
};
